module.exports = __webpack_public_path__ + "assets/img/b2c-hero-2.c837d29e.png";